import RecentActivity from "./RecentActivity";

export default RecentActivity;
